import { getGeo } from '@/pages-v2/home/storeList/component/StoreFilter/components/StoreCityFilter/utils'
import { defaultInteractionFilterValues } from './state'
import { cityValuesMap, requesterMap, exceptFilterKey, exceptFilterKeyBR } from './utils'
import { fetchBizoppTitle, fetchShopContactInfo, getStrategyTag } from '@/api'
import { trackEvent } from '@/common/utils/log'
import { cloneDeep } from 'lodash-es'
import { getBDCountry } from '@/common/utils/i18n'
async function requestListData(
  { commit, state, getters },
  { callback, pageSize = 20, reset = false },
) {
  if (state.searchNot) {
    return
  }
  commit('setLoading', true)
  const lists = state.lists || {}
  const currentTab = state.currentTab
  const currentListData = lists[currentTab] || {}
  let shopIds = []
  if (state.myStoreTabFromNewStore) {
    // 来自新店
    shopIds = state.expireShopIds
  } else if (state.myStoreTab && state.isFromNewRsFlag) {
    // 来自消息中心点击
    shopIds = state.newRsListShopIds || []
  } else if (state.myStoreTab) {
    shopIds = state.unCompleteShopIds || []
  }
  console.log('-refresh-list-', state)
  const params = {
    pageNo: currentListData.pageNo || 1,
    pageSize: pageSize || currentListData.pageSize || 20,
  }
  params.shopIds = shopIds
  const { data: ListData = [] } = currentListData
  if (reset) {
    params.pageNo = 1
    commit('updateListData', {
      currentTab,
      result: {
        ...params,
        total: 0,
        data: [],
      },
    })
  } else {
    params.pageNo += 1
  }
  const requester = requesterMap[currentTab]
  const citiesOptions = getters.citiesOptions || []
  const city = citiesOptions.find(item => item.id === getters.filterValues.cityId)
  // const { bdAreaIds = [] } = getters.filterValues
  if (!city) {
    callback && callback()
    commit('setLoading', false)
    return
  } else {
    // TODO: 城市特殊逻辑
    // if (bdAreaIds.length === 0) {
    //   const reduceChildren = (acc, cur) => {
    //     if (cur.children && cur.children.length > 0) {
    //       return acc.concat(cur.id, cur.children.reduce(reduceChildren, []))
    //     } else {
    //       return acc.concat(cur.id)
    //     }
    //   }
    //   const areaIds = city.children.reduce(reduceChildren, [])
    //   if (!areaIds.length) {
    //     callback && callback()
    //     commit('setLoading', false)
    //   }
    //   params.bdAreaIds = areaIds || []
    // commit('updateFilterValues', { ...params }) // 需要更新一下bdAreaIds
    // }
  }
  const geo = await getGeo(reset)
  params.lat = geo.lat
  params.lng = geo.lng
  // 处理诊断 分数
  const { diagnosisScoreStart, diagnosisScoreEnd } = getters.filterValues
  const scoreFlag = diagnosisScoreStart === 0 && diagnosisScoreEnd === 100
  params.diagnosisScoreFlag = scoreFlag ? 0 : 1
  // 处理签约状态
  const { status } = getters.filterValues
  params.status = status.map(item => {
    return item.split(':')[1]
  })
  // 请求之前记录一下时间戳
  commit('updateTimeStamp', Date.now())
  const wholeParams = { ...getters.filterValues, ...params }
  // if (wholeParams.bdAreaIds.length === 0) {
  //   callback && callback()
  //   commit('setLoading', false)
  //   return
  // }
  requester(wholeParams)
    .then((data = {}) => {
      const { list = [], total } = data || {}
      const _list = list || []
      commit('updateListData', {
        currentTab,
        result: {
          ...params,
          total,
          data: reset ? _list : ListData.concat(_list),
        },
      })
      callback && callback()
      commit('setLoading', false)
      // 埋点
      if (state.timestamp) {
        trackEvent('sailing_gattarman_x_page_ck', {
          id: 'GetStoreListSuccess',
          name: '列表数据获取成功',
          duration: Date.now() - state.timestamp,
        })
        commit('updateTimeStamp', 0)
      }
      if (total === 0) {
        // 清空状态
        commit('updateExpireIdsShopIds', [])
        commit('updateNewRsListShopIds', [])
        commit('updateFromNewRsFlag', false)
      }
    })
    .catch(() => {
      commit('setLoading', false)
      callback && callback()
    })
}

function updateCityAndAreaValue(
  { commit, state, getters },
  { cityId = '', bdAreaIds = [], callback },
) {
  const currentTab = state.currentTab
  const keys = cityValuesMap[currentTab]
  if (keys && keys.length === 2) {
    const params = {
      [keys[0]]: cityId,
      [keys[1]]: bdAreaIds,
    }
    commit('updateFilterValues', { ...params })
    updateAllTabBycityChange({ commit, state, getters })
  } else if (keys) {
    console.log('keys数组的长度不是2')
  } else {
    console.log('未找到当前城市的keys值')
  }
}
function updateAllTabBycityChange({ commit, state, getters }) {
  const { lists } = state
  for (const key in lists) {
    // eslint-disable-next-line no-prototype-builtins
    if (lists.hasOwnProperty(key)) {
      const data = lists[key].data
      if (Array.isArray(data)) {
        if (data.length !== 0) {
          commit('updateListData', {
            currentTab: key,
            result: {
              pageNo: 1,
              total: 0,
              data: [],
            },
          })
        }
      }
    }
  }
}
export default {
  // 更新当前Tab值
  updateCurrentTab({ commit, state, getters }, { currentTab }) {
    commit('updateSearchNot', false)
    commit('updateCurrentTab', currentTab)
    const lists = state.lists || {}
    const currentListData = lists[currentTab] || {}
    const { data = [] } = currentListData
    // 没有数据时请求
    if ((data || []).length === 0) {
      // console.log('数据请求-')
      requestListData({ commit, state, getters }, { reset: true })
    }
  },
  // 更新筛选项值
  updateFilterValues({ commit, state, getters }, { callback, ...params }) {
    commit('updateSearchNot', false)
    const { cityId = '', bdAreaIds = [], ...Lparams } = params
    // NOTES: 以防万一，对商圈城市和普通城市区别设置
    if (cityId) {
      updateCityAndAreaValue({ commit, state, getters }, { cityId, bdAreaIds })
    }
    commit('updateFilterValues', { ...Lparams })
    requestListData({ commit, state, getters }, { callback, reset: true })
  },
  // 更新筛选项枚举
  updateFilterOptions({ commit, state }, params = {}) {
    commit('updateFilterOptions', params)
  },
  // 请求列表数据
  requestListData({ commit, state, getters }, { callback, pageSize, reset = false }) {
    commit('updateSearchNot', false)
    requestListData({ commit, state, getters }, { callback, pageSize, reset })
  },
  // 设置loading属性
  setLoading({ commit }, params) {
    commit('setLoading', params)
  },
  // 根据tab更新CityId和areaId属性
  updateCityAndAreaValue({ commit, state, getters }, { cityId = '', bdAreaIds = [], callback }) {
    commit('updateSearchNot', false)
    updateCityAndAreaValue({ commit, state, getters }, { cityId, bdAreaIds, callback })
    requestListData({ commit, state, getters }, { callback, reset: true })
  },
  // 刷新shoplist接口字段
  refreshListDataWithExpireIdsOrNewRs({ commit, state, getters }) {
    requestListData({ commit, state, getters }, { reset: true })
  },
  // 重置筛选项：只重置最左侧的筛选项
  resetInteractionFilterValues({ commit, state, getters }) {
    const country = getBDCountry() || 'MX'
    const keys =
      country === 'BR' ? exceptFilterKeyBR[state.currentTab] : exceptFilterKey[state.currentTab]
    const defaultValues = { ...defaultInteractionFilterValues }
    keys.forEach(item => {
      delete defaultValues[item]
    })
    commit('updateSearchNot', false)
    // 只重置最左侧的筛选集合，所以把其他筛选的重置去掉
    delete defaultValues.sortType
    delete defaultValues.bdUserName
    // 为什么要删除这个？
    // delete defaultValues.arrTag
    commit('updateFilterValues', defaultValues)
    requestListData({ commit, state, getters }, { reset: true })
  },
  // 设置额外的tips筛选项
  setOtherPageArrStrategyTagId({ commit }, params) {
    commit('setOtherPageArrStrategyTagId', params)
  },
  // 首页跳转过来展示和设置标签的action
  selectCityAndTagId({ commit, state, getters }, { cityId = '', tagIds = [], currentTab }) {
    const indexTagIds = tagIds.map(num => num.toString())
    const arrTags = state.filterOptions.arrTag || []
    const hasTagIds = arrTags
      .filter(item => indexTagIds.includes(item.value.toString()))
      .map(item => item.value.toString())
    commit('updateSearchNot', false)
    commit('setOtherPageArrStrategyTagId', tagIds)
    commit('updateCurrentTab', currentTab)
    const params = {
      arrTag: hasTagIds,
    }
    // 只需要取
    const { cityIds = [] } = state.filterOptions || {}
    const currentCity = cityIds.find(item => item.id === cityId) || {}
    const { children = [] } = currentCity || {}

    const bdAreaIds = (children || []).reduce((arg = [], item = {}) => {
      return arg.concat((item.children || []).map(item => item.id))
    }, [])
    if (cityId) {
      params.cityId = cityId
      params.bdAreaIds = bdAreaIds
    }
    commit('updateFilterValues', params)
    updateAllTabBycityChange({ commit, state, getters })
    requestListData({ commit, state, getters }, { reset: true })
  },
  getStatusNum({ commit, state }, params) {
    fetchBizoppTitle(params).then(res => {
      // 这里拿到签约状态的数值
      commit('updateCountByStatus', res.data)
      return res.data
    })
  },
  getShopContactInfo({ commit, state }, params) {
    return fetchShopContactInfo(params).then(res => {
      commit('updatePhoneInfo', res.data)
      return res.data
    })
  },
  // 获取业务策略数据放到filter筛选项里
  getStrategyTag({ commit, state }, params) {
    return getStrategyTag(params).then(res => {
      if (res && res.data && res.data.strategyTag) {
        const tagResult = res.data.strategyTag
        const copyStrategyTag = cloneDeep(tagResult)
        copyStrategyTag.sort((a, b) => a.categoryId - b.categoryId)
        for (const category of copyStrategyTag) {
          category.tagId = `tags${category.categoryId}`
          const children = []
          for (const child of category.children) {
            const childObj = {}
            childObj.value = child.tagId
            childObj.label = child.tagName
            children.push(childObj)
          }
          category.children = children
        }
        commit('updateStrategyTag', copyStrategyTag)
        const childrenArr = []
        for (const obj of copyStrategyTag) {
          childrenArr.push(...obj.children)
        }
        commit('updateFilterOptions', {
          arrTag: childrenArr,
        })
        return {
          strategyTag: copyStrategyTag,
        }
      }
    })
  },
}
